module.exports = __webpack_public_path__ + "img/7.9dcb9d03.jpg";